import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";
import * as angular from "angular";
import * as moment from "moment";

import { EntityConfigService } from "../services/entity-config-service";
import { AccountService } from "../services/account-service";
import { LocalCacheService } from "../services/local-cache-service";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { SearchService } from "../services/search-service";
import { CustomViewsService } from "../services/custom-views-service";

RLAssociationTableHierarchyItem.$inject = ["$compile"];
export function RLAssociationTableHierarchyItem($compile: ng.ICompileService) {
    var directive: ng.IDirective = {
        restrict: "EA",
        bindToController: true,
        controller: RLAssociationTableHierarchyItemController,
        controllerAs: "athiVM",
        require: ["rlAssociationTableHierarchyItem"],
        scope: {
            charTypeID: "=charTypeId",
            document: "=",
            hierarchy: "=",
            visibility: "=",
            locked: "=",
            canEdit: "=",
            isParentChar: "=",
            entityID: "=entityId",
            refreshPanel: "=",
            targetRecordID: "=targetRecordId",
            previewRecordID: "=previewRecordId",
            detailsUrl: "=",
            parentOpen: "=",
            level: "@",
            availableColumns: "=?",
            customColumns: "=?",
            templateMetaData: "=?",
            sortDir: "=?",
            sortField: "=?",
            previewEntityID: "=?previewEntityId",
        },
        template: require("/assets/app/templates/association-table-hierarchy-item.html"),
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {

            var ctrl: RLAssociationTableHierarchyItemController = controllers[0];

            scope.$watch(() => ctrl.childEntityDocuments,
                () => {
                    if (_.any(ctrl.childEntityDocuments) && ctrl.open) {
                        var template =
                            "<tr rl-association-table-hierarchy-item='' ng-show='athiVM.open && athiVM.parentOpen' ng-repeat='childEntityDoc in athiVM.childEntityDocuments' document='childEntityDoc.root' hierarchy='childEntityDoc' visibility='athiVM.visibility' char-type-id='athiVM.charTypeID' custom-columns='athiVM.customColumns' available-columns='athiVM.availableColumns'  selectable='false' locked='athiVM.locked' can-edit='athiVM.canEdit' is-parent-char='athiVM.isParentChar' entity-id='athiVM.entityID' refresh-panel='athiVM.refreshPanel' parent-open='athiVM.open' level='{{ athiVM.levelInt + 1 }}' target-record-id='athiVM.document.recordID' preview-entity-id='athiVM.previewEntityID' ng-class=\"{'preview-row':athiVM.previewEntityID==childEntityDoc.root.entityID}\"></tr>";
                        var el = angular.element(template);
                        var compiled = $compile(el);
                        element.after(el);
                        compiled(scope);
                    }
                });

        }
    }
    return directive;
}

class RLAssociationTableHierarchyItemController {
    static $inject = ["$scope", "$q", "$rootScope", "$filter", "$location", "$window", "entityConfigService", "accountService", "localCacheService", "entityService", "notifyService", "eventService", "searchService", 'customViewsService'];

    charTypeID: number;
    selectable: boolean;
    allChecked: boolean;
    firstTimeThroughComplete: boolean;
    visibility: number;

    availableColumns: Models.IListTableColumn[];

    customColumns: Models.ICustomUserColumns;

    selectedListID: string;
    charTypeUrl: string;

    document: Models.IEntitySearchDoc;
    childEntityDocuments: Models.IEntityHierarchy[];
    hierarchy: Models.IEntityHierarchy;

    row: Models.IListTableRow;

    locked: boolean;
    canEdit: boolean;
    isParentChar: boolean;
    entityID: string;
    refreshPanel: boolean;
    level: string;
    levelInt: number;
    url: string;
    childCount: number;
    open: boolean;
    arrowClass: string;
    showEntityCallback: (entityID: string) => void;
    emptyClass: string;
    isDirectParentOrChild: boolean;
    targetRecordLevel: number;
    targetRecordID: number;
    previewRecordID: number;
    detailsUrl: string;
    parentOpen: boolean;
    loading: boolean;
    previewEntityID: string;

    constructor(
        $scope: ng.IScope,
        private $q: ng.IQService,
        private $rootScope: ng.IRootScopeService,
        private $filter: ng.IFilterService,
        private $location: ng.ILocationService,
        private $window: ng.IWindowService,
        private entityConfigService: EntityConfigService,
        private accountService: AccountService,
        private cacheService: LocalCacheService,
        private entityService: EntityService,
        private notifyService: NotifyService,
        private eventService: EventService,
        private searchService: SearchService,
        private customViewsService: CustomViewsService) {

        this.arrowClass = "fa-caret-right";
        this.emptyClass = "mrm";
        this.open = true;

        $scope.$watch(() => this.open, (newValue: boolean, oldValue: boolean) => {
            var open = newValue;
            var newClass = "";

            if (this.childCount > 0) {
                if (open) {
                    newClass = "fa-caret-down prx";
                } else {
                    newClass = "fa-caret-right prs";
                }
            }

            this.arrowClass = newClass;
        });

        $scope.$watch(() => this.charTypeID, (newValue, oldValue) => {
            this.charTypeUrl = Utils.UrlBuilder.getCharTypeSummaryUrl(this.charTypeID);
        });

        $scope.$watch(() => this.parentOpen, (newValue: boolean, oldValue: boolean) => {
            if (!this.firstTimeThroughComplete && this.levelInt > 0) {
                this.open = false;
                this.firstTimeThroughComplete = true;
            } else {
                if (newValue) {
                    this.open = true;
                    this.getChildren(5);
                } else {
                    this.open = false;
                }
            }
        });

        $scope.$watchCollection(() => [this.document, this.customColumns, this.availableColumns], (newValue, oldValue) => {
            if (this.customColumns && this.document && this.availableColumns) {
                this.setupRows(this.document, this.customColumns.columns);
            }
        });

        $scope.$on(Consts.Events.RefreshViewEntity, (e, data) => {
            this.previewEntityID = data;
        });
    }

    $onInit() {
        this.levelInt = _.parseInt(this.level);

        this.childEntityDocuments = this.hierarchy.children;
        if (this.hierarchy.children != null) {
            if (this.hierarchy.children.length == 0) {
                this.searchService.getEntityHierarchy(this.document.entityID, this.document.charTypeID, 1)
                    .then((result) => {
                        if (result.success) {
                            this.childCount = result.data.children.length;

                            if (this.childCount > 0) {
                                this.arrowClass = "fa-caret-right prs";
                            }
                        }
                    });
            }
            else {
                this.childCount = this.hierarchy.children.length;
            }
        }
    }

    private setupRows(row: Models.IEntitySearchDoc, customColumns: Models.ICustomUserColumn[]) {
        var specialColumns = this.customViewsService.GetSpecialColumns(this.charTypeID);

        customColumns.forEach((col) => {
            if (col.solrLabel.indexOf("_date") > -1 || col.solrLabel.indexOf("_updated") > -1 || col.solrLabel == "created") {
                col.formatter = 'dateLocal:"L"';
            }

            // nearly duplicate of code from column-picker.ts, refactor
            if (col.solrLabel.indexOf("_") > -1) {
                var split = col.solrLabel.split("_");
                col.label = "";
                split.forEach((val) => {
                    col.label += val.substr(0, 1).toUpperCase() + val.substr(1, val.length - 1) + " ";
                });
            } else if (col.solrLabel == "userlabel") {
                col.label = "Contact";
            } else if (col.solrLabel == "companylabel") {
                col.label = "Company";
            } else if (col.solrLabel == "created") {
                col.label = "Created";
            }

            if (col.solrLabel == "transaction_id") {
                col.label = "Deal ID";
            }
        });

        var sortedColumns = _.sortBy(customColumns, (col) => { return col.sequenceNumber; });

        var columns: Models.IListTableColumn[] = [];
        sortedColumns.forEach((col) => {
            if (col.characteristicID) {
                let characteristic = _.find(this.availableColumns, (aCol) => {
                    return aCol.characteristicID === col.characteristicID;
                });

                // actual characteristic
                if (row.characteristics[characteristic.solrLabel]) {
                    columns.push({
                        characteristicID: col.characteristicID,
                        solrLabel: characteristic.solrLabel,
                        label: characteristic.label || characteristic.solrLabel,
                        value: _.isArray(row.characteristics[characteristic.solrLabel]) ? row.characteristics[characteristic.solrLabel][0] : row.characteristics[characteristic.solrLabel],
                        formatter: characteristic.formatter,
                        dataTypeID: characteristic.dataTypeID,
                        systemIndicatorID: characteristic.systemIndicatorID
                    });
                }
                // header-level
                else if (row[characteristic.solrLabel]) {
                    columns.push({
                        characteristicID: col.characteristicID,
                        solrLabel: characteristic.solrLabel,
                        label: characteristic.label,
                        value: row[characteristic.solrLabel],
                        formatter: characteristic.formatter,
                        dataTypeID: characteristic.dataTypeID,
                        systemIndicatorID: characteristic.systemIndicatorID
                    });
                }
                else if (characteristic) {
                    columns.push({
                        characteristicID: -1,
                        solrLabel: col.solrLabel,
                        label: characteristic.label,
                        value: undefined,
                        dataTypeID: -1,
                        systemIndicatorID: -1
                    });
                }
                // missing from this record
                else {
                    columns.push({
                        characteristicID: -1,
                        solrLabel: col.solrLabel,
                        label: col.label,
                        value: undefined,
                        dataTypeID: -1,
                        systemIndicatorID: -1
                    });
                }
            }
            else if (col.solrLabel) {
                let characteristic = _.find(this.availableColumns, (aCol) => {
                    return aCol.solrLabel === col.solrLabel;
                });

                var specialCol = _.find(specialColumns, (sCol) => {
                    return sCol.solrLabel == col.solrLabel;
                });
                var test = this.customViewsService.GetDefaultColumns(this.charTypeID).columns;
                var defaultCol = _.find(test, (dCol) => {
                    return dCol.solrLabel == col.solrLabel;
                });

                if (specialCol) {
                    col.label = specialCol.label;
                }
                else if (defaultCol) {
                    col.label = defaultCol.label;
                }

                // actual characteristic
                if (characteristic) {
                    columns.push({
                        characteristicID: col.characteristicID,
                        solrLabel: characteristic.solrLabel,
                        label: characteristic.label,
                        value: row[characteristic.solrLabel] || row.characteristics[characteristic.solrLabel],
                        formatter: characteristic.formatter,
                        dataTypeID: characteristic.dataTypeID,
                        systemIndicatorID: characteristic.systemIndicatorID
                    });
                }
                // header value
                else if (row[col.solrLabel]) {
                    columns.push({
                        characteristicID: -1,
                        solrLabel: col.solrLabel,
                        label: col.label,
                        value: row[col.solrLabel],
                        formatter: col.formatter,
                        dataTypeID: -1,
                        systemIndicatorID: -1
                    });
                }
                // specially indexed value that is not an actual characteristic
                else if (row.characteristics[col.solrLabel]) {
                    columns.push({
                        characteristicID: -1,
                        solrLabel: col.solrLabel,
                        label: col.label || col.solrLabel,
                        value: row.characteristics[col.solrLabel],
                        formatter: col.formatter,
                        dataTypeID: -1,
                        systemIndicatorID: -1
                    });
                }
                // header value with underscore - we need to access value without but sort with
                else if (col.solrLabel.indexOf("_") > -1) {
                    var split = col.solrLabel.split("_");
                    var label = split[0];
                    split.splice(0, 1);

                    split.forEach((val) => {
                        label += val.substr(0, 1).toUpperCase() + val.substr(1, val.length - 1);
                    });

                    columns.push({
                        characteristicID: -1,
                        solrLabel: col.solrLabel,
                        label: col.label || col.solrLabel,
                        value: row[label],
                        formatter: col.formatter,
                        dataTypeID: -1,
                        systemIndicatorID: -1
                    });
                }
                // dummy value
                else {
                    columns.push({
                        characteristicID: -1,
                        solrLabel: col.solrLabel,
                        label: col.label || col.solrLabel,
                        value: undefined,
                        dataTypeID: -1,
                        systemIndicatorID: -1
                    });
                }
            }
        });

        this.row = {
            recordID: row.recordID,
            columns: columns,
            recordRevisionID: row.recordRevisionID,
            title: row.title,
            currency: row.characteristics["currency_str"]
        };
    }

    private setCustomColumnList(charTypeID: number, headerID: string) {
        var key = `CC-${charTypeID}-${headerID}`;
        var colList = this.cacheService.getItem(key);

        if (!colList) {
            this.getCustomListColumns()
                .then(() => {

                });
        }
    }

    private getCustomListColumns() {
        return this.accountService.getCustomColumns()
            .then((res) => {
                var dayExp = moment.duration(1, "day");
                res.forEach((customColumns) => {
                    this.cacheService.setItem(`CC-${customColumns.charTypeID}-${customColumns.headerID}`, customColumns, dayExp);
                });
            });
    }

    //Association Table specific
    //The rest of this logic is the same as with list-table.ts
    RemoveAssociation(recordID: number) {
        if (this.$window.confirm("Are you sure?")) {
            this.notifyService.startProgress();

            var parsedEntityID = Utils.IdBuilder.splitEntityID(this.document.entityID);

            var parentEntity = Utils.IdBuilder.buildEntityID(parsedEntityID.divID, this.charTypeID, this.targetRecordID);
            var childEntity = Utils.IdBuilder.buildEntityID(parsedEntityID.divID, this.charTypeID, recordID);

            this.entityService.deleteAssociation(parentEntity, childEntity)
                .then(() => {
                    this.refreshPanel = true;
                    this.eventService.call(Consts.Events.ValidateEntity)
                        .then(() => {
                            this.notifyService.notifySuccess("Association removed");
                        });

                })
                .finally(() => {
                    this.refreshPanel = true;
                    this.notifyService.endProgress();
                });
        }
    }

    PreviewEntity(recordID: number) {
        var parsedEntityID = Utils.IdBuilder.splitEntityID(this.entityID);
        var rowEntityID = Utils.IdBuilder.buildEntityID(parsedEntityID.divID, this.charTypeID, recordID);
        this.previewEntityID = rowEntityID;
        this.$rootScope.$broadcast(Consts.Events.ViewEntity, rowEntityID);
    }
    //--

    //Association Table Hierarchy specific
    Toggle() {
        if (this.level != null && this.levelInt > 0) {
            this.open = !this.open;
            this.getChildren(5);
        } else {
            this.parentOpen = !this.parentOpen;
        }
    }

    private getChildren(hierarchyDepth: number = 1) {
        if (this.childCount !== this.childEntityDocuments.length) {
            this.loading = true;
            this.searchService.getEntityHierarchy(this.document.entityID, this.document.charTypeID, hierarchyDepth)
                .then((results) => {
                    if (results.success) {
                        this.childEntityDocuments = results.data.children;
                        this.document = results.data.root;
                    }
                    this.loading = false;
                });
        }
    }
}
